export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndAvailableCreditAmount: true,
        },
    },
    reservations: {
        useCardIdEnabled: true,
    },
    invoices: {
        showNewInvoicesDeliveryView: {
            enabled: true,
        },
        oldEndPoint: true,
    },
    preferOutstandingAmount: true,
    supplementary: {
        allowHiddenCardImage: true,
    },
};
